export function getCellElementByIndex({
  rowIndex,
  colIndex,
}: {
  rowIndex: number;
  colIndex: number;
}): HTMLTableCellElement | null {
  return document.querySelector(
    `[data-row-index="${rowIndex}"][data-col-index="${colIndex}"]`
  );
}
